import { render, staticRenderFns } from "./LandingContact.vue?vue&type=template&id=a1c8405e&scoped=true"
import script from "./LandingContact.vue?vue&type=script&lang=js"
export * from "./LandingContact.vue?vue&type=script&lang=js"
import style0 from "./LandingContact.vue?vue&type=style&index=0&id=a1c8405e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c8405e",
  null
  
)

export default component.exports